import {
    TextField,
    Filter,
    TextInput,
    usePermissions,
    useResourceContext,
    FunctionField,
    useTranslate,
} from "react-admin";
import { DefaultPagination } from "shared/src/components/DefaultPagination";
import { ToolbarWithHistory } from "shared/src/components/ToolbarWithHistory";
import { DatagridWithHistory } from "shared/src/components/DatagridWithHistory";
import { queryToAttribute } from "shared/src/utils/decodeQuery";
import { AccessRightsError } from "shared/src/components/AccessRightsError";
import { RaSelectInput } from "shared/src/components/inputs/Ra/RaSelectInput";
import { RaDateField } from "shared/src/components/fields/Ra/RaDateField";
import { RaEditButton } from "shared/src/components/buttons/RaEditButton";
import { RaDeleteButton } from "shared/src/components/buttons/RaDeleteButton";
import { RaListView } from "shared/src/components/views/RaListView";
import { AutocompleteInput } from "shared/src/components/inputs/AutocompleteInput";
import { TextField as MuiTextField } from "@mui/material";
import { handleHttpError } from "shared/src/utils/errorHandler";
import { useState } from "react";

const ListFilter = ({ repairShop, setRepairShop, ...props }) => {
    const translate = useTranslate();

    return (
        <Filter {...props}>
            <TextInput
                title={translate("equip.name")}
                label="equip.name"
                source="search"
                alwaysOn
            />
            <RaSelectInput
                source="state"
                choices={[
                    {
                        id: "rental_inprogress",
                        name: "equip.rental_inprogress",
                    },
                    { id: "open", name: "equip.open" },
                    {
                        id: "return_inprogress",
                        name: "equip.return_inprogress",
                    },
                    {
                        id: "partially_returned",
                        name: "equip.partially_returned",
                    },
                    { id: "returned", name: "equip.returned" },
                    { id: "closed", name: "equip.closed" },
                ]}
                alwaysOn
            />
            <AutocompleteRepairShopInput
                value={repairShop}
                setValue={setRepairShop}
                alwaysOn
            />
        </Filter>
    );
};

export const RepairOrderList = (props) => {
    const resource = useResourceContext();
    const translate = useTranslate();
    const attribute = queryToAttribute();
    const { isLoading, permissions } = usePermissions();
    const [repairShop, setRepairShop] = useState("");

    if (isLoading) {
        return <></>;
    } else if (!permissions.vote({ resource, attribute })) {
        return <AccessRightsError />;
    }
    return (
        <RaListView
            {...props}
            actions={<ToolbarWithHistory export={true} create={true} />}
            filters={<ListFilter setRepairShop={setRepairShop} />}
            pagination={<DefaultPagination />}
            perPage={50}
            sort={{ field: "id", order: "DESC" }}
            filter={{ repairShop: repairShop?.id }}
            {...(repairShop && { empty: false })}
        >
            <DatagridWithHistory bulkActionButtons={false}>
                <FunctionField
                    label="ID"
                    source="id"
                    render={(record) =>
                        record.edispoId
                            ? `${record.id} / ${record.edispoId}`
                            : record.id
                    }
                />
                <TextField label="equip.name" source="name" />
                <TextField
                    label="equip.repairShop"
                    source="repairShop.name"
                />
                <TextField
                    label="equip.items"
                    source="itemCount"
                    sortable={false}
                />
                <FunctionField
                    label="equip.state"
                    source="state"
                    render={(record) => translate("equip." + record.state)}
                />
                <RaDateField label="equip.startDate" source="startDate" />
                <RaDateField label="equip.endDate" source="endDate" />
                <RaEditButton />
                <RaDeleteButton />
            </DatagridWithHistory>
        </RaListView>
    );
};

const AutocompleteRepairShopInput = ({ value, setValue }) => {
    return (
        <AutocompleteInput
            value={value}
            setValue={setValue}
            resource="repairShops"
            labelKey="equip.repairShop"
            sort={{ field: "name", order: "ASC" }}
            filterBy={"name"}
            renderOptionLabel={({ name }) => `${name}`}
            RenderInputComponent={MuiTextField}
            handleError={handleHttpError}
            sx={{ width: 400 }}
        />
    );
};
